document.addEventListener('show.bs.offcanvas', (evt) => {
  // handle any offcanvas in #main and allow for z-index adjusting
  if (!evt.target.closest('#header')) {
    document.querySelector('body').classList.add('offcanvas-open')
  }
  // handle any style adjustments when the compare drawer is open
  if (evt.target.getAttribute('id') == 'compare-drawer') {
    document.querySelector('body').classList.add('compare-open');
  }
  if (evt.target.getAttribute('id') == 'search-drawer') {
    document.querySelector('body').classList.add('search-open');
  }
});
document.addEventListener('hidden.bs.offcanvas', () => {
  document.querySelector('body').classList.remove('offcanvas-open');
  document.querySelector('body').classList.remove('compare-open');
  document.querySelector('body').classList.remove('search-open');
})